<!-- Skip to content link for accessibility -->
<a href="#main-content" class="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-main-500 focus:text-white focus:rounded-md">
  {{ 'ACCESSIBILITY.SKIP_TO_CONTENT' | translate }}
</a>

<!-- Hero -->
<section class="relative h-[920px] lg:h-[670px] bg-gray-50" id="main-content">
  <div class="absolute inset-0 z-50 py-20 lg:py-0 bg-gradient-to-r from-black/70 to-black/30">
    <div class="container text-white h-full flex flex-col md:items-center lg:flex-row gap-10 md:gap-3">
      <div class="md:flex-1 flex flex-col gap-2.5 lg:gap-4">
        <h1 class="text-4xl md:text-5xl lg:text-6xl font-black" [innerHTML]="'HOME.HERO.TITLE' | translate"></h1>
        <p class="lg:text-lg">{{ 'HOME.HERO.DESCRIPTION' | translate }}</p>
        <div class="flex flex-col md:flex-row items-center gap-1.5 lg:gap-3.5">
          <a routerLink="/hairdressers"
             class="w-full md:w-auto flex items-center justify-center gap-1 text-sm px-6 py-3 rounded-md border-2 border-main-600 bg-main-600 text-white hover:bg-main-700 hover:border-main-700 duration-150 focus:outline-none focus:ring-2 focus:ring-main-500 focus:ring-offset-2">
            <lucide-icon [img]="Search" [size]="18" aria-hidden="true"/>
            <span>{{ 'HOME.HERO.LINK.FIND_HAIRDRESSER'| translate }}</span>
          </a>
          <a routerLink="/auth/signup" [queryParams]="{status:'hairdresser'}"
             class="w-full md:w-auto flex items-center justify-center gap-1 text-sm px-6 py-3 rounded-md border-2 hover:bg-white/20 duration-150 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-black/30">
            <lucide-icon [img]="UserRoundPlus" [size]="18" aria-hidden="true"/>
            <span>{{ 'HOME.HERO.LINK.JOIN_AS_HAIRDRESSER'| translate }}</span>
          </a>
        </div>
      </div>
      <div class="md:flex-1 flex items-center justify-end">
        <form [formGroup]="searchForm" (ngSubmit)="onSubmitForm()"
              class="px-6 py-12 md:p-10 rounded-lg border border-white/20 bg-white/15 backdrop-blur w-full md:max-w-md">
          <h2 class="font-medium text-lg md:text-xl mb-4">{{ 'HOME.HERO.SEARCH_FORM.TITLE'| translate }}</h2>
          <div class="flex flex-col gap-3.5">
            <app-places-autocomplete formControlName="address"
                                     [placeholder]="'HOME.HERO.SEARCH_FORM.FIELDS.ADDRESS.PLACEHOLDER'| translate"/>
            <app-hairstyles-autocomplete [hairstyles]="hairstyles()"
                                         [placeholder]="'HOME.HERO.SEARCH_FORM.FIELDS.HAIRSTYLE.PLACEHOLDER' | translate"
                                         formControlName="hairstyle"/>
          </div>
          <button type="submit"
                  class="mt-3.5 text-sm font-medium w-full px-6 py-3.5 rounded-lg flex items-center justify-center gap-1.5 text-white bg-main-600 hover:bg-main-700 duration-150 focus:outline-none focus:ring-2 focus:ring-main-300 focus:ring-offset-2">
            <lucide-icon [img]="Search" [size]="20" aria-hidden="true"/>
            <span>{{ 'HOME.HERO.SEARCH_FORM.SEARCH'| translate }}</span>
          </button>
        </form>
      </div>
    </div>
  </div>
  <swiper-container class="select-none w-full h-full" init="false" braidsbookSwiper [swiperOptions]="swiperHeroOptions()"
                    [attr.aria-label]="'ACCESSIBILITY.HERO_CAROUSEL_LABEL' | translate" role="region">
    @for (image of SWIPER_IMAGES(); track $index) {
      <swiper-slide class="w-full h-full relative">
        <img [ngSrc]="image.src" [alt]="image.alt | translate" fill priority class="object-cover">
      </swiper-slide>
    }
  </swiper-container>
  <nav class="swiper-pagination" role="navigation" [attr.aria-label]="'ACCESSIBILITY.CAROUSEL_PAGINATION_LABEL' | translate"></nav>
</section>

<!-- How It Works -->
<app-how-it-works></app-how-it-works>

<!-- Why Choose Us -->
<app-why-choose-us></app-why-choose-us>

<!-- Advertising -->
<app-ad-banner></app-ad-banner>

<!-- Download APP -->
<app-download-app></app-download-app>
